export const prepareBase64Data = (rawBase64Data: string, { defaultMimeType = 'application/octet-stream' }: { defaultMimeType?: string } = {}): { type: string; data: string } => {
  const regex = /data:\w+\/\w+;base64,/;
  const meta = rawBase64Data.match(regex)?.[0];

  if (!meta?.length) {
    return {
      type: defaultMimeType,
      data: rawBase64Data,
    };
  }

  const truncatedData = rawBase64Data.slice(meta.length);
  const type = meta.split(';')[0]?.split(':')[1];

  return {
    type,
    data: truncatedData,
  };
};